import axiosInstance from "@/api/axios-instance";

export interface FixItem {
  usage_id: string;
  new_status?: "ACTIVE" | "COMPLETED" | "EXPIRED";
  new_utilized_session_quantity?: number;
  session_ids_to_link?: string[];
}

export async function fixBundleDiscrepancies(fixes: FixItem[]): Promise<{
  success: boolean;
  fixed: number;
}> {
  const response = await axiosInstance.patch("/audit/fix-discrepancies", {
    fixes,
  });
  return response.data;
}
